import { generatePageUrl } from '@utils';

export const BASE_URL = '/';
export const PRODUCTS_PER_PAGE = 6;
export const SUPPORT_EMAIL = 'support@maccaron.in';
export const PROVIDERS = {
  BRAINTREE: {
    label: 'Braintree',
  },
  DUMMY: {
    label: 'Dummy',
  },
  STRIPE: {
    href: 'https://js.stripe.com/v3/',
    label: 'Stripe',
  },
};
export const STATIC_PAGES = [
  {
    label: 'About',
    url: generatePageUrl('about'),
  },
];
// export const SOCIAL_MEDIA = [
//   {
//     ariaLabel: "facebook",
//     href: "https://www.facebook.com/mirumeelabs/",
//     path: require("../images/facebook-icon.svg"),
//   },
//   {
//     ariaLabel: "instagram",
//     href: "https://www.instagram.com/mirumeelabs/",
//     path: require("../images/instagram-icon.svg"),
//   },
//   {
//     ariaLabel: "twitter",
//     href: "https://twitter.com/getsaleor",
//     path: require("../images/twitter-icon.svg"),
//   },
//   {
//     ariaLabel: "youtube",
//     href: "https://www.youtube.com/channel/UCg_ptb-U75e7BprLCGS4s1g/videos",
//     path: require("../images/youtube-icon.svg"),
//   },
// ];
// export const META_DEFAULTS = {
//   custom: [],
//   description:
//     "Open-source PWA storefront built with Saleor's e-commerce GraphQL API. Written with React and TypeScript.",
//   image: `${window.location.origin}${require("../images/logo.svg")}`,
//   title: "Demo PWA Storefront – Saleor Commerce",
//   type: "website",
//   url: window.location.origin,
// };
export enum CheckoutStep {
  Address = 1,
  Shipping,
  Payment,
  Review,
}

export const CHECKOUT_STEPS = [
  {
    index: 0,
    link: '/checkout/address',
    name: 'Address',
    nextActionName: 'Continue to Shipping',
    nextStepLink: '/checkout/shipping',
    onlyIfShippingRequired: true,
    step: CheckoutStep.Address,
  },
  {
    index: 1,
    link: '/checkout/shipping',
    name: 'Shipping',
    nextActionName: 'Continue to Payment',
    nextStepLink: '/checkout/payment',
    onlyIfShippingRequired: true,
    step: CheckoutStep.Shipping,
  },
  {
    index: 2,
    link: '/checkout/payment',
    name: 'Payment',
    nextActionName: 'Continue to Review',
    nextStepLink: '/checkout/review',
    onlyIfShippingRequired: false,
    step: CheckoutStep.Payment,
  },
  {
    index: 3,
    link: '/checkout/review',
    name: 'Review',
    nextActionName: 'Place order',
    nextStepLink: '/order-finalized',
    onlyIfShippingRequired: false,
    step: CheckoutStep.Review,
  },
];

export const staticUrl = 'https://vely-dev-media-bucket.s3.ap-south-1.amazonaws.com/';

export const uiComponentVariables = {
  notice: {
    name: 'notice',
  },
  brandStory: {
    name: 'brand-story',
    desktopSize: '900x530',
    mobileSize: '900x530',
  },
  brandsBanner: {
    name: 'brands-banner',
    desktopSize: '147x116',
    mobileSize: '147x116',
  },
  luxuryBrandLogos: {
    name: 'luxury-brand-logos',
    desktopSize: '590x549',
    mobileSize: '590x549',
  },
  featuredCategory: {
    name: 'featured-category',
    desktopSize: '590x549',
    mobileSize: '590x549',
  },
  slideBanner: {
    name: 'slide-banner',
    desktopSize: '1920x405',
    mobileSize: '590x549',
  },
  slideBannerCom: {
    name: 'slide-banner-com',
    desktopSize: '1920x405',
    mobileSize: '590x549',
  },
  stripBanner: {
    name: 'strip-banner',
    desktopSize: '1700x611',
    mobileSize: '1080x440',
  },
  mainOffers: {
    name: 'main-offers',
    desktopSize: '900x530',
    mobileSize: '900x530',
  },
  mainOffersCom: {
    name: 'main-offers-com',
    desktopSize: '900x530',
    mobileSize: '900x530',
  },
  luxuryBrandOffers: {
    name: 'luxury-brand-offers',
    desktopSize: '900x530',
    mobileSize: '900x530',
  },
  testimonial: {
    name: 'testimonial',
    desktopSize: '900x530',
    mobileSize: '900x530',
  },
  // freebieEvent: {
  //   name: "freebie-event",
  //   desktopSize: "1700x611",
  //   mobileSize: "1080x440",
  // },
  specialCollection1: {
    name: 'special-collection-acne-skin',
    desktopSize: '1700x611',
    mobileSize: '1080x440',
  },
  // brands
  topBrandWeb: {
    name: 'top-brand-web',
    desktopSize: '768x350',
    mobileSize: '768x350',
  },
  topBrandWebCom: {
    name: 'top-brand-web-com',
    desktopSize: '768x350',
    mobileSize: '768x350',
  },
  onlyAtMaccaronWeb: {
    name: 'only-at-maccaron-web',
    desktopSize: '768x350',
    mobileSize: '768x350',
  },
  newLaunchWeb: {
    name: 'new-launch-web',
    desktopSize: '768x350',
    mobileSize: '768x350',
  },
  cleanBeauty: {
    name: 'Clean Beauty-Brand-Web',
    desktopSize: '768x350',
    mobileSize: '768x350',
  },

  topBrandLuxuryWeb: {
    name: 'top-brand-luxury-web',
    desktopSize: '768x350',
    mobileSize: '768x350',
  },

  trendingKeywordsMobile: {
    name: 'trending-keywords-mobile',
    desktopSize: '768x350',
    mobileSize: '768x350',
  },

  luxuryBrandBanners: {
    name: 'luxury-brand-banners',
    desktopSize: '1700x611',
    mobileSize: '590x549',
  },
  newFlashSale: {
    name: 'flash-sale-mobile',
  },
  homeTabRankCategory: {
    name: 'home-tab-rank-category',
    mobileSize: '147x116',
  },
  invisibleBrand:{
    name: 'invisible-brand'
  }
};

export const exhibitionIDs = {
  mostPopular: process.env.MOST_POPULAR_EXHIBITION_ID,
  skyrocketingInPopularity: process.env.SKYROCKETING_IN_POPULARITY_EXHIBITION_ID,
};

export const imageWebSize = {
  freebie_event_contents: '1700x611',
  popup_contents: '500x500',
};
export const imageMobileSize = {
  freebie_event_contents: '1080x440',
  slide_banner_contents: '1080x440',
  featured_category: '590x549',
  main_offers_contents: '900x530',
  testimonials: '900x530',
  brands_banner_contents: '147x116',
  popup_contents: '500x500',
  strip_banner_contents: '1080x440',
};

export const RESOLVE_ERROR_MESSAGE = "Couldn't resolve to a node";
